import { Navigate, useNavigate, useParams } from "react-router-dom";
import { TopBar } from "../../../../widgets";
import { CustomToast, DividerThin } from "../../../../shared";
import { Fragment, useEffect, useRef, useState } from "react";
import { Button, Flex, InputNumber } from "antd";
import './index.css'
import { ThunkDispatch } from "redux-thunk";
import { useDispatch, useSelector } from "react-redux";
import { getProgramBookingAsync } from "../../../../modules/programBooking";
import { RootState } from "../../../../modules";
import { useGetProgramById } from "./model";
import WellnessProgramBookCalendar from "./ui/wellnessProgramBookCalendar";
import dayjs from "dayjs";
import BookingSecondStepFooter from "../secondStep/footer";
import { ConfirmBottomSheet } from "../secondStep/confirmBottomSheet";
import { isIOS } from "react-device-detect";
import { ReactComponent as Add } from "../../../../assets/images/icon/add.svg";
import { ReactComponent as Minus } from "../../../../assets/images/icon/minus.svg";
import { finishedSelectProgramBasic, selectProgramQuantity } from "../../../../utils/gtm";

const WellnessProgramBookFirstStep = () => {
    const id = Number(useParams().id);
    const dispatch: ThunkDispatch<any, any, any> = useDispatch();
    const navigate = useNavigate();
    const update = getProgramBookingAsync;
    const [showMaxCntToast, setShowMaxCntToast] = useState<boolean>(false);
    const { form, ticketList } = useSelector((state: RootState) => state.programBooking);
    const [isShowConfirmButtomSheet, setIsShowConfirmButtomSheet] = useState<boolean>(false);
    const alertToastTimerRef = useRef<ReturnType<typeof setTimeout> | null>(null);
    const { data, isFetching } = useGetProgramById(id, 'id, title, thumbnailImageUrl, locationName, isPaid, isDisableBooking programTicketList { id, name, description, payAmount } programEventList { id targetDateTime isActive isMaxBooking bookingCnt maxBookingCnt } programSelectOptionList { id idx name description isRequired } programSubjectOptionList { id idx name description isRequired }')
    const countRef = useRef<HTMLDivElement | null>(null);
    const dateRef = useRef<HTMLDivElement | null>(null);
    const timeRef = useRef<HTMLDivElement | null>(null);
    const [toastText, setToastText] = useState<string>('');
    const [isShowToast, setIsShowToast] = useState<boolean>(false);
    const [isDisabled, setIsDisabled] = useState<boolean>(data?.isDisableBooking ?? false);

    const updateFromInitDate = (targetTicketList: IProgramBookingTicket[]) => {
        if (!data) return;
        const filteredDateList = getAbleEventList(targetTicketList)
        const filteredTargetDateTime = filteredDateList?.map(q => q.targetDateTime ? dayjs(q.targetDateTime).format('YYYY-MM-DD') : undefined)
        const targetDate = filteredTargetDateTime.filter(q => q === form.date).length > 0 ? filteredTargetDateTime.filter(q => q === form.date)[0] : filteredTargetDateTime[0]
        updateForm('date', targetDate, targetTicketList)
    }
    const increase = (key: string) => {
        if (!data) return
        const targetTicketList = ticketList.map(ticket => ticket.name === key ? { ...ticket, count: ticket.count + 1 } : ticket)
        selectProgramQuantity(data.title, data.isPaid ? targetTicketList.map(q => q.name).join(',') : '-', targetTicketList.reduce((acc, ticket) => acc + ticket.count, 0), data.isPaid ? targetTicketList.reduce((acc, ticket) => acc + (ticket.payAmount * ticket.count), 0) : 0)
        updateFromInitDate(targetTicketList)
    };
    const decrease = (key: string) => {
        if (!data) return
        const targetTicketList = ticketList.map(ticket => ticket.name === key ? { ...ticket, count: ticket.count - 1 } : ticket);
        selectProgramQuantity(data.title, data.isPaid ? targetTicketList.map(q => q.name).join(',') : '-', targetTicketList.reduce((acc, ticket) => acc + ticket.count, 0), data.isPaid ? targetTicketList.reduce((acc, ticket) => acc + (ticket.payAmount * ticket.count), 0) : 0)
        updateFromInitDate(targetTicketList)
    };
    const getTotalBookingCnt = () => {
        return ticketList.reduce((sum, ticket) => sum + ticket.count, 0);
    }
    const getTotalBookingPrice = () => {
        return ticketList.reduce((sum, ticket) => sum + (ticket.payAmount * ticket.count), 0);
    }
    const updateForm = (key: string, value: number | string | undefined, targetTicketList?: IProgramBookingTicket[]) => {
        const updatedCount = { ...form, [key]: value };
        dispatch(update({ form: updatedCount, ticketList: targetTicketList ?? ticketList }))
    }
    const onClickNextStepButton = () => {
        if (!data) return;
        finishedSelectProgramBasic(data.title, data.isPaid ? ticketList.map(q => q.name).join(', ') : '-', ticketList.reduce((acc, ticket) => acc + ticket.count, 0), data.isPaid ? ticketList.reduce((acc, ticket) => acc + (ticket.payAmount * ticket.count), 0) : 0, form[`date`]?.toString(), form[`startTime`]?.toString())
        if (data.isPaid) {
            if (getTotalBookingPrice() === undefined || getTotalBookingPrice() === 0) {
                countRef.current?.scrollIntoView({ behavior: 'smooth' })
                setToastText('티켓을 추가해 주세요.')
                return setIsShowToast(true);
            } else if (!form.date) {
                dateRef.current?.scrollIntoView({ behavior: 'smooth' })
                setToastText('날짜를 선택해 주세요.')
                return setIsShowToast(true);
            } else if (!form["eventId"]) {
                timeRef.current?.scrollIntoView({ behavior: 'smooth' })
                setToastText('시간을 선택해 주세요.')
                return setIsShowToast(true);
            }
        } else {
            if (getTotalBookingCnt() <= 0) {
                countRef.current?.scrollIntoView({ behavior: 'smooth' })
                setToastText('인원을 추가해 주세요.')
                return setIsShowToast(true);
            } else if (!form.date) {
                dateRef.current?.scrollIntoView({ behavior: 'smooth' })
                setToastText('날짜를 선택해 주세요.')
                return setIsShowToast(true);
            } else if (!form["eventId"]) {
                timeRef.current?.scrollIntoView({ behavior: 'smooth' })
                setToastText('시간을 선택해 주세요.')
                return setIsShowToast(true);
            }
        }

        if (data.programSelectOptionList.length + data.programSubjectOptionList.length > 0) {
            navigate(`/wellness-program/book/second-step/${id}`)
        } else {
            setIsShowConfirmButtomSheet(true)
        }
    }

    const getAbleEventList = (targetTicketList: IProgramBookingTicket[] = ticketList) => {
        if (!data) return [];
        const ticketCount = targetTicketList.reduce((sum, ticket) => sum + ticket.count, 0)
        return data.programEventList
            .filter(event => event.isActive && !event.isMaxBooking)
            .filter(event => (event.maxBookingCnt - event.bookingCnt - ticketCount) >= 0)
            .filter(event => dayjs(event.targetDateTime).isAfter(dayjs().add(1, 'hour')))
            .filter(event => !checkFullBookingDateList()?.map(q => q.format('YYYY-MM-DD')).includes(dayjs(event.targetDateTime).format('YYYY-MM-DD')))
    }

    const getBookingData = (): IBookingData => {
        const returnValue = {
            programId: id,
            title: form[`title`]?.toString(),
            imageUrl: form[`imageUrl`]?.toString(),
            locationName: form[`locationName`]?.toString(),
            date: form[`date`]?.toString(),
            startTime: form[`startTime`]?.toString(),
            totalBookingCtn: getTotalBookingCnt(),
            totalPrice: Number(form['totalPrice']),
            eventId: Number(form['eventId']),
            optionList: {
                selectOptionList: data?.programSelectOptionList
                    ? data.programSelectOptionList
                        .filter(selecteOption => Object.keys(form).some(key => key.includes(`programSelectOption-${selecteOption.id}`)))
                        .map(selecteOption => ({
                            id: String(selecteOption.id),
                            idx: selecteOption.idx ?? 0,
                            name: selecteOption.name,
                            description: selecteOption.description,
                            isRequired: selecteOption.isRequired,
                            selectedOptionId: form[`programSelectOption-${selecteOption.id}`]?.toString(),
                            selectedOptionName: data.programSelectOptionItemList.find(item => item.id === form[`programSelectOption-${selecteOption.id}`])?.name ?? ''
                        }))
                    : [],
                subjectOptionList: data?.programSubjectOptionList
                    ? data.programSubjectOptionList
                        .filter(subjectOption => Object.keys(form).some(key => key.includes(`programSubjectOption-${subjectOption.id}`)))
                        .map(subjectOption => ({
                            id: String(subjectOption.id),
                            idx: subjectOption.idx ?? 0,
                            name: subjectOption.name,
                            description: subjectOption.description,
                            isRequired: subjectOption.isRequired,
                            value: form[`programSubjectOption-${subjectOption.id}`]?.toString()
                        }))
                    : []
            },
            ticketList: ticketList
        }
        return returnValue
    }

    const checkFullBookingDateList = () => {
        if (!data) return;
        if (Number(data.id) === 2) {
            return [dayjs('2025-05-17', 'YYYY-MM-DD'), dayjs('2025-06-14', 'YYYY-MM-DD')]
        } else if (Number(data.id) === 3) {
            return [dayjs('2025-05-31', 'YYYY-MM-DD'), dayjs('2025-06-07', 'YYYY-MM-DD')]
        } else if (Number(data.id) === 4) {
            return [dayjs('2025-05-24', 'YYYY-MM-DD'), dayjs('2025-06-28', 'YYYY-MM-DD')]
        }
        return []
    }

    useEffect(() => {
        if (!data) return;
        const ableFirstEventList = getAbleEventList().sort((a, b) => dayjs(a.targetDateTime).diff(dayjs(b.targetDateTime)));
        const ableFirstEvent = ableFirstEventList?.[0]
        const targetWellnessProgram = {
            'id': data.id,
            'title': data.title,
            'imageUrl': data.thumbnailImageUrl,
            'locationName': data.locationName,
            'date': ableFirstEvent ? dayjs(ableFirstEvent?.targetDateTime).format('YYYY-MM-DD') : undefined,
            'startTime': ableFirstEvent ? dayjs(ableFirstEvent.targetDateTime).format('HH:mm') : undefined
        };

        const targetTicketList = data.isPaid
            ? data.programTicketList?.map((programTicekt: IProgramTicket, idx) =>
            ({
                id: programTicekt.id,
                name: programTicekt.name,
                description: programTicekt.description,
                payAmount: programTicekt.payAmount,
                count: idx === 0 ? 1 : 0
            }))
            : [{
                id: 0,
                name: 'free',
                description: '무료',
                payAmount: 0,
                count: 1
            }];
        dispatch(update({ form: targetWellnessProgram, ticketList: targetTicketList }))
    }, [data])

    useEffect(() => {
        if (!data) return;
        const ableEvent = getAbleEventList()
        if (ableEvent.length <= 0) {
            setIsDisabled(true)
            setShowMaxCntToast(true);
            if (alertToastTimerRef.current) {
                clearTimeout(alertToastTimerRef.current);
            }
            alertToastTimerRef.current = setTimeout(() => {
                setShowMaxCntToast(false);
            }, 3000);
        } else {
            setIsDisabled(false)
        }
        return () => { setShowMaxCntToast(false); clearTimeout(alertToastTimerRef.current ?? undefined); }
    }, [ticketList, form.eventId]);

    if (isNaN(id)) return <Navigate to={'/explore'} />
    return <>
        <TopBar title="예약" rightIcon={false} />
        <div ref={countRef} style={{ paddingTop: 24 }}>
            {data?.isPaid
                ? <div>
                    {data?.programTicketList?.sort((a, b) => a.id - b.id)?.map((programTicket, idx, arr) =>
                        <Fragment key={idx}>
                            <div style={{ display: "flex", alignItems: "center", justifyContent: 'space-between', padding: '12px 20px', userSelect: 'none', gap: 16 }}>
                                <div>
                                    <div className="sub-title/st3 secondary/s850" style={{ marginBottom: 4 }}>
                                        {programTicket.name}
                                    </div>
                                    <div className="sub-title/st2 secondary/s600" style={{ marginBottom: 4 }}>
                                        {programTicket.payAmount?.toLocaleString()}원
                                    </div>
                                    <div className="body/b2 secondary/s600">
                                        {programTicket.description}
                                    </div>
                                </div>
                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                    <Minus width={16} height={16} fill={(ticketList.find(ticket => ticket.name === programTicket.name)?.count ?? 0) === 0 ? 'var(--secondarys300)' : 'var(--secondarys850)'} style={{ padding: 8, cursor: 'pointer' }} onClick={() => (ticketList.find(ticket => ticket.name === programTicket.name)?.count ?? 0) !== 0 && decrease(programTicket.name)} />
                                    <InputNumber
                                        inputMode='decimal'
                                        className="centered-input"
                                        variant='borderless'
                                        value={ticketList.find(ticket => ticket.name === programTicket.name)?.count ?? 0}
                                        min={0}
                                        onChange={q => updateForm(programTicket.name, q ?? 0)}
                                        controls={false}
                                        style={{ boxShadow: 'none', width: 48 }}
                                    />
                                    <Add width={16} height={16} fill="var(--secondarys850)" style={{ padding: 8, cursor: 'pointer' }} onClick={() => increase(programTicket.name)} />
                                </div>
                            </div>
                            {idx !== arr.length - 1 && <div style={{ paddingInline: 20 }}> <DividerThin style={{ height: 1, marginBlock: '16px' }} /></div>}
                        </Fragment>)}
                </div>
                : <div style={{ display: "flex", alignItems: "center", justifyContent: 'space-between', paddingInline: 20 }}>
                    <div className="sub-title/st3">
                        인원
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <Minus width={16} height={16} fill={(ticketList.find(ticket => ticket.name === 'free')?.count ?? 0) <= 1 ? 'var(--secondarys300)' : 'var(--secondarys850)'} style={{ padding: 8, cursor: 'pointer' }} onClick={() => (ticketList.find(ticket => ticket.name === 'free')?.count ?? 0) > 1 && decrease('free')} />
                        <InputNumber
                            inputMode='decimal'
                            className="centered-input"
                            variant='borderless'
                            value={ticketList.find(ticket => ticket.name === 'free')?.count ?? 0}
                            min={1}
                            onChange={q => updateForm('free', q ?? 0)}
                            controls={false}
                            style={{ boxShadow: 'none', width: 48 }}
                        />
                        <Add width={16} height={16} fill="var(--secondarys850)" style={{ padding: 8, cursor: 'pointer' }} onClick={() => increase('free')} />
                    </div>
                </div>}
        </div>
        {data?.isPaid
            ? <DividerThin style={{ height: 6, marginBlock: '32px' }} />
            : <div style={{ paddingInline: 20 }}> <DividerThin style={{ height: 1, marginBlock: '32px' }} /></div>}
        <div style={{ paddingInline: '20px' }} ref={dateRef}>
            {data &&
                <WellnessProgramBookCalendar
                    key={form.date}
                    initDate={form.date?.toString()}
                    onChange={(date) => {
                        const { eventId, startTime, ...updatedForm } = form;
                        const updatedCount = { ...updatedForm, date: date };
                        dispatch(update({ form: updatedCount, ticketList: ticketList }))
                    }}
                    onActiveDateList={getAbleEventList().map((event) => dayjs(event.targetDateTime).format("YYYY-MM-DD"))}
                    fullBookingDateList={checkFullBookingDateList()}
                />}

        </div>
        <div style={{ padding: '32px 20px' }}>
            <DividerThin />
        </div>
        <div style={{ padding: '0 20px 20px 20px', marginBottom: '30px' }}>
            <div className="sub-title/st3" style={{ marginBottom: '12px' }}>
                시간
            </div>
            <Flex style={{ marginTop: 20 }} ref={timeRef}>
                {!form.date && '날짜를 선택해 주세요.'}
                {data?.programEventList
                    .filter((event) => dayjs(event.targetDateTime).format('YYYY-MM-DD') === form.date)
                    .sort((a, b) => dayjs(a.targetDateTime).diff(dayjs(b.targetDateTime)))
                    .map((event) => {
                        const isDisableTime = (!event.isActive || event.isMaxBooking) || dayjs(event.targetDateTime).add(-1, 'hour').isBefore(dayjs()) || ((event.maxBookingCnt - event.bookingCnt - ticketList?.reduce((sum, ticket) => sum + ticket.count, 0)) < 0);
                        const targetTime = dayjs(event.targetDateTime).format('HH:mm');
                        return <div
                            key={event.id}
                            onClick={() => {
                                if (!isDisableTime) {
                                    const updatedCount = { ...form, 'eventId': event.id, 'startTime': targetTime };
                                    dispatch(update({ form: updatedCount, ticketList: ticketList }))
                                }
                            }}
                            className="sub-title/st2"
                            style={{ padding: '8px 12px', marginRight: '12px', color: isDisableTime ? 'var(--secondarys400)' : form["eventId"] === event.id ? 'var(--basewhite)' : 'var(--secondarys600)', backgroundColor: isDisableTime ? 'var(--secondarys200)' : form["eventId"] === event.id ? 'var(--baseblack)' : 'var(--basewhite)', border: form["eventId"] === event.id ? '1px solid transparent' : '1px solid var(--secondarys300)', borderRadius: 'var(--radius4)' }}>
                            {targetTime}
                        </div>
                    }
                    )}
            </Flex>
        </div>
        {showMaxCntToast &&
            <div
                className="body/b2 base/white"
                style={{
                    position: 'fixed',
                    bottom: isIOS ? 34 : 20,
                    transform: 'translateX(-50%)',
                    zIndex: 3,
                    padding: '12px 0',
                    left: '50%',
                    backgroundColor: '#000000B2',
                    borderRadius: 'var(--radius4)',
                    textAlign: 'center',
                    color: 'white',
                    animation: 'fade-in-out 3s ease-in-out',
                    maxWidth: '480px',
                    width: 'calc(100% - 40px)'
                }}
                onClick={() => setShowMaxCntToast(false)}
            >
                <div>예약 가능한 인원을 초과하였습니다.</div>
                <div>인원을 조정해 주세요.</div>
            </div>
        }
        {data?.isPaid
            ? <BookingSecondStepFooter
                style={{ backgroundColor: 'var(--basewhite)', border: 'none' }}
                disabled={isDisabled}
                date={!form.date ? undefined : `${dayjs(form.date?.toString()).format("YYYY.MM.DD (ddd)")}  ${form.startTime ?? ''}`}
                totalBookingPrice={getTotalBookingPrice()}
                text="다음"
                onClickBookingBtn={onClickNextStepButton} />
            : <div style={{ padding: '20px', paddingBottom: isIOS ? '46px' : '20px', backgroundColor: 'var(--basewhite)' }}>
                <Button
                    disabled={isDisabled}
                    color="default"
                    variant="solid"
                    className="sub-title/st3 base/white"
                    style={{ width: '100%', height: '51px', display: 'flex', alignItems: 'center', justifyContent: 'center', border: 'none' }}
                    onClick={onClickNextStepButton}>
                    다음
                </Button>
            </div>}

        {isShowConfirmButtomSheet &&
            <ConfirmBottomSheet
                isOpen={isShowConfirmButtomSheet}
                setIsOpen={setIsShowConfirmButtomSheet}
                bookingData={getBookingData()}
                isPaid={data?.isPaid === true}
            />}
        {isShowToast && <CustomToast text={toastText} setToast={setIsShowToast} style={{ zIndex: 2 }} />}
    </>
}

const CustomButton = ({ style, disabled, ...props }: React.ButtonHTMLAttributes<HTMLDivElement>) => {
    return <div
        {...props}
        style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', borderRadius: '50%', width: '32px', height: '32px', textAlign: 'center', cursor: disabled ? 'default' : 'pointer', ...style }}
    />
}
export { WellnessProgramBookFirstStep }